import React, { FC } from 'react';
import { HStack, ModalCloseButton, ModalHeader, Text } from '@chakra-ui/react';
import { TokensPair } from '@app/components/TokensPair';

interface Props {
  token0Symbol: string | undefined;
  token1Symbol: string | undefined;
  tokenId: string;
}

export const ModalTitle: FC<Props> = ({
  token0Symbol,
  token1Symbol,
  tokenId
}) => {
  return (
    <>
      <ModalHeader
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Text fontSize={24} color="gray.15">
          Make an Offer
        </Text>
        <ModalCloseButton />
      </ModalHeader>
      {token0Symbol && token1Symbol && (
        <HStack
          sx={{
            alignItems: 'center',
            gap: 3,
            border: '1px solid',
            borderColor: 'neutral.500',
            backgroundColor: 'black',
            padding: '16px',
            borderRadius: '12px',
            mt: 4
          }}
        >
          <TokensPair token0Symbol={token0Symbol} token1Symbol={token1Symbol} />
          <Text fontSize={20} color="white" fontWeight={500}>
            {token0Symbol}-{token1Symbol}
          </Text>
          <Text color="gray.15" fontSize={20} fontWeight={500}>
            ID:{tokenId}
          </Text>
        </HStack>
      )}
    </>
  );
};
